//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Builder.js";
import "../Features/Features.SelectFeature.js";
import "../no/SelectTaggedObject.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../Features/Features.SelectFeatureList.js";
import "../no/SelectTaggedObjectList.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"SourceFeature",0,"Features.SelectFeature",0],[1,"SourceObject",0,"SelectTaggedObject",0],[0,"TargetComponentSelection",1,0],[1,"TargetComponents",0,"Assemblies.SelectComponentList",0],[1,"TargetFeatures",0,"Features.SelectFeatureList",0],[1,"TargetObjects",0,"SelectTaggedObjectList",0]],[[["containerObj"],"IsSourcePaintableObjectContainer",{R_:{result:''}},1,0],[["sourceContainer","targetObjTag","nTargetContainer"],"GetCompatibleTargetObjectContainers",{R_:{targetContainers:"NXObject[]"}},2,0]],[]];
SPLM.Features.PaintParametersBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.PaintParametersBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;